class HeaderCountryController {
    /*@ngInject*/
    constructor($log, $rootScope, CommonService) {
        $log.debug('HeaderCountryController initialized');
        this.$log = $log;
        this.commonService = CommonService;
        this.isLoggedIn = false;

        $rootScope.$on('personalizeRequestSuccess', () => {
            this.isLoggedIn = this.commonService.getPersonalizeRequestResponse().isLoggedIn;
        });
    }

    getIsLoggedIn() {
        return this.isLoggedIn;
    }
}

export default HeaderCountryController;
